// Praxisdaten - zentral verwaltet, einfach anpassbar
export const PRAXIS = {
  name: "Dr. med. Inka Scheer",
  role: "Fachärztin für Gynäkologie & Geburtshilfe",
  street: "Nibelungenstraße 40a",
  zip: "68642",
  city: "Bürstadt",
  phone: "06206 96 33 20",
  phoneRaw: "+49 6206 963320",
  fax: "06206 70 74 51",
  faxRaw: "+49 6206 707451",
  email: "info@praxis-scheer.de",
  web: "www.praxis-scheer.de",
  webUrl: "https://www.praxis-scheer.de"
};

export const SPRECHZEITEN = [
  { day: "Montag", time: "08:00 – 12:30 Uhr" },
  { day: "Dienstag", time: "Vormittag nach Vereinbarung\n14:30 – 19:00 Uhr" },
  { day: "Mittwoch", time: "08:00 – 12:30 Uhr" },
  { day: "Donnerstag", time: "08:00 – 12:30 Uhr\n14:30 – 18:00 Uhr" },
  { day: "Freitag", time: "08:00 – 12:30 Uhr" }
];

export const LEISTUNGEN = [
  {
    slug: "schwangerschaft",
    title: "Schwangerschaft",
    icon: "baby",
    short: "Einfühlsame Betreuung von Kinderwunsch bis zur Geburt.",
    bullets: [
      "Beratung bei Kinderwunsch",
      "Vorsorge nach Mutterschaftsrichtlinien",
      "3D / 4D Ultraschall"
    ]
  },
  {
    slug: "beckenboden",
    title: "Beckenboden & Kontinenz",
    icon: "heart",
    short: "Mitglied der Deutschen Kontinenzgesellschaft – mit spezieller Beckenbodensprechstunde.",
    bullets: [
      "Abklärung bei Blasenschwäche & Senkung",
      "Therapie wiederkehrender Harnwegsinfekte",
      "Beckenbodentraining & Pessartherapie"
    ]
  },
  {
    slug: "wechseljahre",
    title: "Wechseljahre",
    icon: "leaf",
    short: "Wechseljahre sind ein zentrales Thema – selbstverständlich auch in jedem regulären Termin. Für mehr Flexibilität gibt es jetzt zusätzlich die private Videosprechstunde.",
    bullets: [
      "Ausführliche Anamnese & Hormondiagnostik",
      "Ganzheitliche Beratung zur Hormontherapie",
      "Individuelle Behandlungskonzepte",
      "Begleitung durch Peri- und Postmenopause",
      "Neu: zusätzlich als private Videosprechstunde"
    ],
    hasPage: true,
    isNew: true,
    newLabel: "Neu: Videosprechstunde"
  },
  {
    slug: "gynaekologie",
    title: "Gynäkologie",
    icon: "stethoscope",
    short: "Umfassende frauenärztliche Betreuung für alle Lebensphasen.",
    bullets: [
      "Krebsfrüherkennung & Vorsorge",
      "Verhütungsberatung (Pille, Spirale, Implanon u. v. m.)",
      "Sexualmedizin & psychosomatische Grundversorgung",
      "Mädchensprechstunde & Impfberatung",
      "Diagnostik sexuell übertragbarer Erkrankungen",
      "Hormonstatus bei Haarausfall & Hirsutismus",
      "Nachsorge gynäkologischer Tumorerkrankungen"
    ]
  },
  {
    slug: "igel",
    title: "IGeL-Leistungen",
    icon: "sparkles",
    short: "Mehr Sicherheit durch erweiterte Diagnostik – auf Wunsch und nach ausführlicher Beratung.",
    bullets: [
      "Erweiterte Krebsvorsorge",
      "Zusatzleistungen in der Schwangerschaft",
      "Individuelle Beratung auf Wunsch"
    ]
  },
  {
    slug: "labor-ultraschall",
    title: "Labor & Ultraschall",
    icon: "microscope",
    short: "Moderne Diagnostik direkt in der Praxis – schnell und zuverlässig.",
    bullets: [
      "Ultraschalluntersuchungen",
      "Labordiagnostik",
      "Hormonanalysen"
    ]
  }
];

export const TEAM = [
  {
    name: "Melanie Kloos",
    role: "Medizinische Fachangestellte",
    img: "/team/melanie.jpg"
  },
  {
    name: "Manuela Marsch",
    role: "Medizinische Fachangestellte",
    img: "/team/manuela.jpg"
  },
  {
    name: "Tina Bechloff",
    role: "Krankenschwester",
    img: "/team/tina.jpg"
  },
  {
    name: "Edona Hashani",
    role: "Medizinische Fachangestellte",
    img: "/team/edona.jpg"
  }
];

export const NEWS = {
  badge: "Neu in der Praxis",
  title: "Videosprechstunde – Menopause & Wechseljahre",
  text: "Das heutige Gesundheitssystem lässt für das so wichtige Thema Wechseljahre leider oft nicht die Zeit, die es verdient. Deshalb biete ich eine private Videosprechstunde an – damit ich mich ganz individuell und ohne Zeitdruck um Sie kümmern kann.",
  bullets: [
    "Beratung in Ihrer vertrauten Umgebung – erleichtert das Sprechen über sensible Themen",
    "Zeitlich flexibel, zeitnah und ohne lange Wartezeiten",
    "Ausführliche Vorab-Informationen per E-Mail",
    "Blutanalysen können bequem beim Hausarzt erfolgen und gemeinsam ausgewertet werden",
    "Vollständig individuelle und ganzheitliche Beratung – ganz ohne Eile"
  ],
  note: "Die Kosten werden nicht von der gesetzlichen Krankenversicherung übernommen. Informationen auf mehr erfahren.",
  cta: "Mehr erfahren",
  link: "/wechseljahre"
};
